<template>
  <div class="quick-start-page">
    <div class="quick-start-page__main">
      <h1 class="quick-start-page__title">Quick start</h1>

      <QuickStartSection
        :section="basics"
        :icon-url="QUICK_START_ONBOARDING_BASICS_ICON"
        section-name="basics"
        :organization-id="organization.id"
      />
      <QuickStartSection
        v-if="secondaryPath"
        :section="secondaryPath"
        :section-name="secondaryPath.goal"
        :organization-id="organization.id"
      />

      <section class="qs-integrations">
        <header class="qs-integrations__header">
          <div class="qs-integrations__heading">
            <img
              :src="QUICK_START_ONBOARDING_INTEGRATIONS_ICON"
              alt=""
              class="qs-integrations__icon-image"
            />
            <h2 class="qs-integrations__title">Integrate with your favorite tools</h2>
          </div>
          <p class="qs-integrations__description">
            We support over 30 popular integrations so you can continue using your favorite tools inside Hubstaff
          </p>
        </header>

        <div class="qs-integrations__row">
          <div class="qs-integrations__logos">
            <a
              v-for="integration in integrations"
              :key="integration.name"
              v-track:click="{ label: '0216 Quick Start CTA Clicked', props: { section: 'integrations', step_key: integration.name } }"
              :href="integrationsUrl"
            >
              <img
                :src="integration.iconUrl"
                :alt="integration.name"
                class="qs-integrations__logo"
              />
            </a>
          </div>
          <a
            v-track:click="{ label: '0216 Quick Start CTA Clicked', props: { section: 'integrations', step_key: 'view_all_integrations' } }"
            class="qs-integrations__link"
            :href="integrationsUrl"
          >
            View all integrations
          </a>
        </div>
      </section>
    </div>

    <div class="quick-start-page__side">
      <aside class="qs-side-panel">
        <div class="qs-side-panel__block">
          <h3 class="qs-side-panel__title">Hubstaff quickstart guide for new users</h3>
          <p class="qs-side-panel__description">This video shows what your team will see</p>
          <a
            v-track:click="{ label: '0216 Quick Start CTA Clicked', props: { section: 'right_rail', step_key: 'quickstart_guide_video' } }"
            class="qs-side-panel__video-link"
            :href="guideVideoUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              :src="QUICK_START_ONBOARDING_QUICK_START_VIDEO_IMG"
              alt="Hubstaff quickstart guide"
              class="qs-side-panel__video-thumbnail"
            />
          </a>
        </div>

        <div class="qs-side-panel__block">
          <h3 class="qs-side-panel__title">Try it yourself</h3>
          <p class="qs-side-panel__description">Download the Hubstaff app and try it out yourself</p>
          <a
            v-track:click="{ label: '0216 Quick Start CTA Clicked', props: { section: 'right_rail', step_key: 'download_desktop_app' } }"
            class="qs-side-panel__download-button"
            :href="downloadAppUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="hi hi-export qs-side-panel__download-icon" />
            Download the desktop app
          </a>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import QuickStartSection from './QuickStartSection.vue';
import {
  QUICK_START_ONBOARDING_BASICS_ICON,
  QUICK_START_ONBOARDING_INTEGRATIONS_ICON,
  QUICK_START_ONBOARDING_QUICK_START_VIDEO_IMG,
} from '~/rails_assets.js';

export default {
  name: 'QuickStartIndex',
  components: { QuickStartSection },
  props: {
    organization: {
      type: Object,
      required: true,
    },
    basics: {
      type: Object,
      required: true,
    },
    secondaryPath: {
      type: Object,
      default: null,
    },
    integrations: {
      type: Array,
      required: true,
    },
    integrationsUrl: {
      type: String,
      required: true,
    },
    downloadAppUrl: {
      type: String,
      required: true,
    },
    guideVideoUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    QUICK_START_ONBOARDING_BASICS_ICON,
    QUICK_START_ONBOARDING_INTEGRATIONS_ICON,
    QUICK_START_ONBOARDING_QUICK_START_VIDEO_IMG,
  }),
};
</script>
